<template>
  <div id="embedded-page-container" :data-test-id="dataTestId">
    <Placeholder name="jss-ss-main" :rendering="rendering" />
  </div>
</template>
<script setup lang="ts">
import { usePageStore } from '@/store';
import { ComponentRendering, Placeholder } from '@sitecore-jss/sitecore-jss-vue';
import { onMounted, onUnmounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps<{
  rendering: ComponentRendering;
}>();
const parentAdobeDataLayout = ref<any[]>([]);

// ---------------------------------------------------------
// Setup observer to adjust iframe height
// ---------------------------------------------------------
const route = useRoute();
const bodyEl = document.querySelector('body');
const dataTestId = usePageStore().dataTestId(props.rendering);
const resizeObserver = new ResizeObserver(() => {
  requestAnimationFrame(() => {
    const iframe = window.parent.document.querySelector(
      (route.query.iframeSelector as string) ?? 'iframe'
    ) as HTMLIFrameElement;
    const bodyHeight = bodyEl?.scrollHeight + 'px';
    if (iframe && bodyHeight != iframe.style.height) iframe.style.setProperty('height', bodyHeight);
    updateAdobeDataLayer();
  });
});

onMounted(() => {
  updateAdobeDataLayer();
  resizeObserver.observe(bodyEl!);
});

onUnmounted(() => {
  resizeObserver.unobserve(bodyEl!);
});

const updateAdobeDataLayer = () => {
  if (window !== window.parent) {
    setTimeout(() => {
      window.parent.adobeDataLayer = [...parentAdobeDataLayout.value, ...(window.adobeDataLayer ?? [])];
    }, 1000);
  }
};
</script>
